<template>
  <div>
    <div class="floating-module">
      <img src="@/assets/logo.gif" alt="在线客服" @click.stop="handleOpenKefu()">
    </div>

    <el-dialog :title="chatTitle" top="10vh" class="chat-dialog" :visible.sync="openkefu" width="800px"
      :close-on-click-modal="false" :before-close="handleClose" append-to-body>

      <div class="chat-message-box" ref="content" :key="idx">
        <div>
          <template v-if="showHello">
            <div align="center" style="padding: 5px;">
              <el-tag type="info" size="mini">{{ getCurrentTimeString() }}</el-tag>
            </div>

            <div class="chat-item-rec">
              <el-avatar shape="square" :src="touxiang1" style="width: 35px;height: 35px;"></el-avatar>
              <div class="chatPop1">
                <span>{{ chatHello }}</span>
              </div>
            </div>

            <div class="chat-item-rec" v-if="questions && questions.length > 0">
              <el-avatar shape="square" :src="touxiang1" style="width: 35px;height: 35px;"></el-avatar>
              <div class="chatPop1">
                <p style="font-size: 16px;">
                  <b> 猜你想问 </b>
                  <el-button type="text" icon="el-icon-refresh" :loading="questionLoaidng"
                    @click.stop="getQuestion"></el-button>
                </p>
                <div v-for="item in questions" class="question" @click.stop="sendQuestion(item)">{{ item.question }}
                </div>
              </div>
            </div>
          </template>
          <!-- <transition-group name="message-list"> -->
          <div v-for="(message, index) in messages" :key="index">

            <div align="center" style="padding: 5px;">
              <el-tag type="info" size="mini" v-if="message.time">{{ message.time }}</el-tag>
            </div>

            <div class="chat-item-rec" v-if="message.role == 'assistant' || message.role == 'system'">
              <el-avatar shape="square" :src="touxiang1" style="width: 35px;height: 35px;"></el-avatar>
              <div class="chatPop1">
                <div v-if="message.thought != ''" class="chat-item-thought">
                  {{ message.actionName }}
                  <vue-markdown :source="message.thought" :anchorAttributes="{ target: '_blank' }"></vue-markdown>
                </div>

                <span class="chat-item-divider" v-show="message.thought && message.content"></span>

                <vue-markdown class="chat-item-content" v-if="message.content != ''" :source="message.content"
                  :anchorAttributes="{ target: '_blank' }"></vue-markdown>

                <div v-if="message.status == 'pending'">
                  <i class="el-icon-loading"></i>
                  <span class="status-text">
                    <i>正在思考...</i>
                  </span>
                </div>

                <div v-else-if="message.status == 'loading'">
                  <i class="el-icon-loading"></i>
                </div>

                <div v-else-if="message.status == 'complete'" class="status-align-right">
                  <el-tooltip v-if="index == messages.length - 1" placement="top" content="再试一次" effect="dark">
                    <el-button type="text" style="padding:0;" @click="handleRetry(message)">
                      <Icon size="16" tag="i" class="status-text">
                        <AutorenewFilled></AutorenewFilled>
                      </Icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip placement="top" content="复制" effect="dark">
                    <el-button type="text" id="copy-btn" :data-clipboard-text="message.content" style="padding:0;">
                      <Icon size="16" tag="i" class="status-text">
                        <ContentCopyRound></ContentCopyRound>
                      </Icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="message.feedback0" placement="top" content="已点赞" effect="dark">
                    <el-button type="text" style="padding:0;">
                      <Icon size="16" class="status-text">
                        <ThumbUpFilled></ThumbUpFilled>
                      </Icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-else placement="top" content="点赞" effect="dark">
                    <el-button type="text" style="padding:0;" @click="handleLike(message)">
                      <Icon size="16" class="status-text">
                        <ThumbUpOutlined></ThumbUpOutlined>
                      </Icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-if="message.feedback1" placement="top" content="已反馈" effect="dark">
                    <el-button type="text" style="padding:0;">
                      <Icon size="16" class="status-text">
                        <ThumbDownFilled></ThumbDownFilled>
                      </Icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip v-else placement="top" content="反馈" effect="dark">
                    <el-button type="text" style="padding:0;" @click="handleFeedback(message)">
                      <Icon size="16" class="status-text">
                        <ThumbDownOutlined></ThumbDownOutlined>
                      </Icon>
                    </el-button>
                  </el-tooltip>

                  <!-- <el-button type="text" class="status-text" icon="el-icon-check"><i>已完成</i></el-button> -->
                </div>

                <div v-else-if="message.status == 'stop'" class="status-align-right">
                  <el-button type="text" class="status-text"><i>已停止回答</i></el-button>
                </div>

                <div v-else-if="message.status == 'error'" class="status-align-right">
                  <el-button type="text" class="status-text"><i>出错了，请稍后再试</i></el-button>
                </div>
              </div>
            </div>

            <div class="chat-item-send" v-if="message.role == 'user'">
              <div class="chatPop2">
                <span>{{ message.content }}</span>
              </div>
              <!-- <el-avatar shape="square" :src="touxiang2" style="width: 35px;height: 35px;"></el-avatar> -->
            </div>
          </div>
          <!-- </transition-group> -->
        </div>

      </div>
      <template #footer>
        <div class="BorderRightBottom">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" v-model="inputText"
            placeholder="您好！这里是众智科技客服，请详细描述您的问题" resize="none" autofocus maxlength="500"
            @keyup.enter.native="handleEnter">
          </el-input>
          <div class="sendButton">
            <el-button v-if="messages.length > 0 && !loading" plain size="small" style="margin-right: 10px;"
              @click="handleNew" icon="el-icon-plus">新建对话</el-button>
            <button size="small" @click="handleChangeThoughts" class="thought-button"
              :class="{ 'thought-button_active': hasThoughts === 1, 'thought-button_disabled': loading }">深度思考</button>
            <el-button v-if="loading" size="small" @click="stop" type="danger" icon="el-icon-loading">
              <span>停止</span>
            </el-button>
            <el-button v-else size="small" @click="sendMessage" type="success" :disabled="!computedInputText"
              :loading="loading">发送(Enter)</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="感谢您的反馈，我们会继续优化进步" :visible.sync="feedbackDialog" width="600px" append-to-body
      :close-on-click-modal="false">
      <el-form :model="feeabackForm" label-position="top">
        <el-form-item label="针对问题">
          <el-checkbox-group v-model="feeabackForm.one">
            <el-checkbox label="不理解问题"></el-checkbox>
            <el-checkbox label="遗忘了上文"></el-checkbox>
            <el-checkbox label="不遵循要求"></el-checkbox>
          </el-checkbox-group>

        </el-form-item>
        <el-form-item label="针对回答效果">
          <el-checkbox-group v-model="feeabackForm.two">
            <el-checkbox label="回答错误"></el-checkbox>
            <el-checkbox label="逻辑混乱"></el-checkbox>
            <el-checkbox label="时效性差"></el-checkbox>
            <el-checkbox label="可读性差"></el-checkbox>
            <el-checkbox label="回答不完整"></el-checkbox>
            <el-checkbox label="回答笼统不专业"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="其他">
          <el-input v-model="feeabackForm.three" type="textarea" placeholder="如果你愿意的话，可以和我们说说你对此回答感到不满意的原因~"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="small" type="primary" :loading="feedbackLoading" @click="submitFeedback">提 交</el-button>
          <el-button size="small" @click="feedbackDialog = false">取 消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import { fetchEventSource } from '@microsoft/fetch-event-source'
  import touxiang1 from '@/assets/guanyu/IP1.png'
  // import touxiang2 from '@/assets/guanyu/jieshao1.png'
  import { addSession, getIp, hrPage, aiSession, getRandomQuestion, aiFeedback } from "@/api/api"
  import { Icon } from '@v2icons/utils'
  import { ThumbUpOutlined, ThumbUpFilled, ThumbDownOutlined, ThumbDownFilled, ContentCopyRound, AutorenewFilled } from '@v2icons/material'
  import Clipboard from 'clipboard'
  export default {
    name: 'SmartFloatKefu',
    props: {

    },
    components: {
      VueMarkdown,
      Icon,
      ThumbUpOutlined,
      ThumbUpFilled,
      ThumbDownOutlined,
      ThumbDownFilled,
      ContentCopyRound,
      AutorenewFilled
    },
    data() {
      return {
        baseUrl: process.env.VUE_APP_BASE_API,
        openkefu: false,
        loading: false,
        inputText: '',
        text: '',
        thought: '',

        messages: [
          // { content: '您好，有什么可以帮到您？', role: 'system', time: this.getCurrentTimeString() },
        ],

        touxiang1: touxiang1,
        // touxiang2: touxiang2,
        ip: '',
        yinyong: '来源：',

        prompt: null,
        hasThoughts: 0,
        sessionId: null,
        questions: [],
        questionLoaidng: false,
        status: 'loading',
        idx: 1,
        feedbackDialog: false,
        feedbackLoading: false,
        feeabackForm: {
          one: [],
          two: [],
          three: null,
        },
        chatTitle: '众智AI客服-Smart',
        chatHello: '您好，有什么可以帮到您？',
        showHello: false
      }
    },
    watch: {
      $route(to, from) {
        this.openkefu = false
      },
    },
    computed: {
      computedInputText() {
        return this.inputText ? this.inputText.trim() : ''
      }
    },

    created() {
      this.getIpAddress()
    },

    mounted() {
      const clipboard = new Clipboard('#copy-btn')
      clipboard.on('success', () => {
        this.$message.success('复制成功')
      })
      clipboard.on('error', () => {
        this.$message.error('复制失败')
      })
    },

    methods: {
      handleOpenKefu() {
        this.loading = false
        this.sessionId = null
        this.openkefu = true
        this.getQuestion()
        this.scrollToBottom()
      },
      getQuestion() {
        this.questionLoaidng = true
        getRandomQuestion(5)
          .then(res => {
            if (res.code === 200) {
              this.questions = res.data.list
              if (!this.showHello) {
                this.chatHello = res.data.description
                this.chatTitle = 'Smart-Al客服' + res.data.title
                this.showHello = true
              }
            }
          })
          .finally(() => {
            this.questionLoaidng = false
          })
      },
      sendQuestion(item) {
        this.inputText = item.question
        this.sendMessage()
      },
      handleEnter(event) {
        this.sendMessage()
      },
      async getIpAddress() {
        getIp().then((res) => {
          this.ip = res.data
        })
      },
      scrollToBottom() {
        this.$nextTick(() => {
          let scrollElem = this.$refs.content
          scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' })
        })
      },
      sendMessage() {
        if (this.loading || !this.computedInputText) return

        this.loading = true
        this.text = ''
        this.thought = ''
        this.yinyong = '来源：'

        const sessionForm = {
          question: this.computedInputText,
          answer: '',
          source: '',
          requestId: null,
          ip: this.ip
        }

        const newMessage = {
          content: this.computedInputText,
          role: "user",
          time: this.getCurrentTimeString()
        }
        this.messages.push(newMessage)

        this.scrollToBottom()
        this.ctrl = new AbortController()

        // const eventSource = aiSession({prompt: this.queryParams.input.prompt, sessionId: this.sessionId}, ctrl.signal);
        let url = `${this.baseUrl}web/aiSession?prompt=${encodeURIComponent(this.computedInputText)}&hasThoughts=${this.hasThoughts}`
        if (this.sessionId) {
          url = url + '&sessionId=' + encodeURIComponent(this.sessionId)
        }

        this.replyMessage = {
          question: this.computedInputText,
          thought: '',
          content: '',
          role: "assistant",
          status: 'pending',
        }
        this.messages.push(this.replyMessage)

        this.inputText = ''

        const that = this

        let completed = false
        let hasWorkflowText = false
        const workflowChunks = new Set()
        const completeResponse = () => {
          if (completed) return
          completed = true
          that.loading = false
          that.replyMessage.status = 'complete'
          that.replyMessage.feedback0 = false
          that.replyMessage.feedback1 = false
          sessionForm.requestId = that.replyMessage.requestId
          sessionForm.answer = that.text
          if (sessionForm.answer) {
            addSession(sessionForm).catch(() => {})
          }
          that.text = ''
          that.thought = ''
        }

        fetchEventSource(url, {
          method: 'GET',
          signal: this.ctrl.signal,
          openWhenHidden: true,
          async onopen(response) {
            if (!response.ok || !(response.headers.get('content-type') || '').includes('text/event-stream')) {
              throw new Error('AI 对话连接失败')
            }
          },
          onmessage(event) {
            if (completed || !event.data || !event.data.trim()) return
            if (event.data.trim() === '[DONE]') {
              completeResponse()
              return
            }

            const jsonData = JSON.parse(event.data)
            if (!jsonData || typeof jsonData !== 'object') return
            if (jsonData.code && String(jsonData.code) !== '200') {
              throw new Error(jsonData.message || 'AI 对话请求失败')
            }
            const output = jsonData.output
            if (!output || typeof output !== 'object') return

            // message_format 将逐段正文放在工作流消息中，结束时还会返回完整 text。
            const workflow = output.workflow_message || output.message
            if (workflow && typeof workflow === 'object') {
              const message = workflow.message || workflow
              if (message && message.role === 'assistant' && typeof message.content === 'string' && message.content) {
                const sequence = workflow.node_msg_seq_id
                const chunkId = sequence == null ? null : `${workflow.node_id || ''}:${sequence}`
                if (chunkId === null || !workflowChunks.has(chunkId)) {
                  if (chunkId !== null) workflowChunks.add(chunkId)
                  that.text += message.content
                  hasWorkflowText = true
                }
              }
            }
            if (hasWorkflowText && output.finish_reason === 'stop' && typeof output.text === 'string' && output.text) {
              that.text = output.text
            } else if (!hasWorkflowText && typeof output.text === 'string') {
              that.text += output.text
            }
            if (Array.isArray(output.thoughts)) {
              output.thoughts.forEach(item => {
                if (!item || typeof item !== 'object') return
                if (typeof item.thought === 'string') that.thought += item.thought
                if (typeof item.action_name === 'string' && item.action_name) {
                  that.replyMessage.actionName = item.action_name
                }
              })
            }
            if (typeof output.session_id === 'string' && output.session_id) {
              that.sessionId = output.session_id
            }
            if (typeof jsonData.request_id === 'string' && jsonData.request_id) {
              that.replyMessage.requestId = jsonData.request_id
            }

            that.replyMessage.content = that.text
            that.replyMessage.thought = that.thought
            that.replyMessage.status = 'loading'

            that.$forceUpdate()
            that.scrollToBottom()
            if (output.finish_reason === 'stop') {
              if (Array.isArray(output.doc_references)) {
                const result = output.doc_references.filter(item => item && typeof item === 'object').map(item => `[${item.index_id}]《${item.doc_name}》`).join('\n')
                that.yinyong += result
                sessionForm.source = that.yinyong
              }
              completeResponse()
            }
          },
          onclose() {
            if (!completed) {
              if (that.text) completeResponse()
              else {
                that.loading = false
                that.replyMessage.status = 'error'
              }
            }
          },
          onerror(err) {
            if (that.ctrl) {
              that.ctrl.abort()
            }
            that.loading = false
            that.replyMessage.status = 'error'
            throw err
          }
        }).catch(() => {})

      },
      handleClose(done) {
        this.$confirm('确认退出对话窗口？')
          .then(_ => {
            this.messages = [
              // { content: '您好，有什么可以帮到您？', role: 'system', time: this.getCurrentTimeString() },
            ]
            this.inputText = null
            this.stop()
            done()
          })
          .catch(_ => { })
      },
      getCurrentTimeString() {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      },
      handleChangeThoughts() {
        if (this.loading) {
          return
        }
        this.hasThoughts = this.hasThoughts ? 0 : 1
      },
      stop() {
        if (this.ctrl) {
          this.ctrl.abort()
          this.loading = false
          this.replyMessage.status = 'stop'
        }
      },
      handleNew() {
        this.messages = []
        this.sessionId = null
        this.idx++
        this.getQuestion()
      },
      handleLike(msg) {
        msg.feedback0 = true
        msg.feedback1 = false
        aiFeedback({
          requestId: msg.requestId,
          status: 0
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$forceUpdate()
          })

      },
      handleFeedback(msg) {
        this.msg = msg
        this.feeabackForm = {
          requestId: msg.requestId,
          status: 1,
          one: [],
          two: [],
          three: null
        }
        this.feedbackDialog = true
      },
      submitFeedback(msg) {
        if (this.feeabackForm.one.length == 0 && this.feeabackForm.two.length == 0 && !this.feeabackForm.three) {
          this.$message.warning('请至少输入一项反馈内容')
          return
        }
        this.feedbackLoading = true

        const form = {
          ...this.feeabackForm,
          one: this.feeabackForm.one.join(','),
          two: this.feeabackForm.two.join(','),
        }
        aiFeedback(form)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('反馈成功')
              this.feedbackDialog = false
              this.msg.feedback1 = true
              this.msg.feedback0 = false
            } else {
              this.$message.error(res.msg)
            }
          })
          .finally(() => {
            this.feedbackLoading = false
          })
      },
      handleCopy(msg) {
        navigator.clipboard.writeText(msg.content)
          .then(() => {
            this.$message.success('复制成功')
          })
          .catch(() => {
            this.$message.error('复制失败')
          })
      },
      handleRetry(msg) {
        const _msg = this.messages.pop()
        this.messages.pop()

        this.inputText = _msg.question
        this.$forceUpdate()
        this.sendMessage()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .floating-module {
    position: fixed;
    right: 0;
    bottom: 8%;
    z-index: 999;
    cursor: pointer;
  }

  @media screen and (max-width: 480px) {
    .floating-module {
      display: none;
    }
  }



  .chat-message-box {
    height: 520px;
    overflow-y: auto;
    background-color: #f5f5f5;
    display: block;
    padding: 5px 15px 20px;
    border: 1px solid #ededed
  }

  .chat-item-rec {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 5px;
  }

  .chat-item-send {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-top: 5px;
  }

  .status-text {
    font-size: 12px;
    color: #bbb;
    padding: 0;

    & :hover {
      color: #409eff;
    }
  }

  .status-align-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .status-complete {
    opacity: 0;
    transition: opacity 0.12s ease-in-out;
  }

  .chatPop1 {
    position: relative;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #E3E3E3;
    max-width: 580px;
    margin-left: 16px;
    transition: background 0.09s ease;

    &:hover {
      background-color: #FAFAFA;
    }

    &:hover .status-complete {
      opacity: 1;
    }

    &::before {
      content: '';
      border: 8px solid #ffffff00;
      border-right: 8px solid #fff;
      position: absolute;
      top: 8px;
      left: -16px;
    }

    p {
      margin: 0;
    }
  }




  .chatPop2 {
    background-color: #2683f5;
    padding: 10px;
    border-radius: 10px;
    position: relative;
    border: 1px solid #E3E3E3;
    max-width: 560px;
    color: #fff;
    // margin-right: 16px;
  }


  .chatPop1,
  .chatPop2 {
    animation: message-in 0.32s ease-in-out;
  }

  @keyframes message-in {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }

  }

  .question {
    cursor: pointer;
    margin-bottom: 5px;
    padding: 5px;
  }

  .question:hover {
    background-color: #ecf5ff;
  }

  .sendButton {
    padding: 10px;
  }

  .thought-button {
    margin-right: 10px;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    line-height: 1;
    border: 1px solid #DCDFE6;
    color: #606266;
    background: #FFF;
    cursor: pointer;
  }

  .thought-button_active {
    color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }

  .thought-button_disabled {
    cursor: not-allowed;
  }

  .chat-dialog {

    ::v-deep .el-textarea__inner {
      border: 0;
    }

    ::v-deep .el-dialog__header {
      padding: 10px 20px;
    }

    ::v-deep .el-dialog__body {
      padding: 0;
    }

    ::v-deep .el-dialog__footer {
      padding: 0px;
    }

    ::v-deep .el-dialog__headerbtn {
      top: 12px;
      right: 17px;
      font-size: 20px;
    }
  }

  .chat-item-thought {
    line-height: 1.6;
    font-size: 13px;
    color: #999;
  }

  .chat-item-divider::after {
    content: "";
    display: block;
    border-bottom: 1px solid #DCDFE6;
  }

  .chat-item-content {
    line-height: 1.6;

    ::v-deep a {
      color: #2683f5;
      text-decoration: underline;
      cursor: pointer;
    }
  }


</style>
